import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetWorkOrderAssetOpenWorkOrdersQuery } from "../../store/services/api/work-order-api";
import {humanizeEnum} from "../../utils/humanizers";
import { WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface WorkOrderAssetOpenWorkOrdersModalProps {
  assetId: string;
  enableEdit?: boolean;
  triggerContent: React.ReactNode;
}

export default function WorkOrderAssetOpenWorkOrdersModal({
  assetId,
  enableEdit,
  triggerContent,
}: WorkOrderAssetOpenWorkOrdersModalProps) {
  const [open, setOpen] = useState(false);
  const [getOpenWorkOrders, { data, isFetching }] =
    useLazyGetWorkOrderAssetOpenWorkOrdersQuery();

 const navigation = useNavigation<any>();
  useEffect(() => {
    if (open) {
      getOpenWorkOrders({ assetId });
    }
  }, [open, assetId, getOpenWorkOrders]);


  const navigateToEdit = (id: string) => navigation.replace('recordView', { id});

  return (
    <>
      <span
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        style={{ cursor: "pointer", color: "#1677ff" }}
      >
        {triggerContent}
      </span>

      <Modal
        centered
        title="Work Orders"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      >
        <Skeleton loading={isFetching} active>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 }}>Work Order Reference</div>
            <div style={{ flex: 2 }}>Type</div>
            <div style={{ flex: 2 }}>Status</div>
            {enableEdit && <div style={{ flex: 2 }}>View Work Order</div>}
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data?.list || []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2 }}>{item.reference}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderType[item.type])}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderStatus[item.status])}</div>
                {enableEdit && <div style={{ flex: 2, textAlign: "right" }}>
                  <Popconfirm
                    title="Are you sure you want to view this work order you have not saved your changes?"
                    onConfirm={() => navigateToEdit(item.id)}
                    >
                      <Button
                        type="link"
                      >
                        View Work Order
                      </Button>

                  </Popconfirm>
                  
                </div>
                }
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
